import { ScrapingAggregateStatusApi } from "@/features/accounts/payment/scraping/services/scrapingaggregate-status-api";
import { GetScrapingAggregateStatusRequestModel } from "@/features/accounts/payment/scraping/services/scrapingaggregate-status-model";

/// アグリゲーション状態取得処理
export class ScrapingAggregateStatusService {
    private aggregateStatusApi = new ScrapingAggregateStatusApi();

    /**
    * アグリゲーション状態取得API実行
    */
    public async getAggregateStatus(param: GetScrapingAggregateStatusRequestModel) {
        return await this.aggregateStatusApi.getAggregateStatus(param);
    }
}
